export const ROUTES = [
  { label: "About", path: "/about" },
  { label: "Annual Conferences", path: "/conferences" },
  { label: "Scholarships", path: "/scholarships" },
  // { label: "Competitions", path: "/competitions" },
  // { label: "Newsletters", path: "/newsletters" },
  // { label: "Contact", path: "/contact" },
];
